<style lang="scss" scoped>
.location-banner {
    position: relative;
    width: 100%;
    height: 360px;

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            225deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
        );

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    .content {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 0 24px;

        @media (min-width: 1024px) {
            padding: 0 40px;
        }

        .title {
            white-space: nowrap;
            line-height: 1;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .description {
            max-width: 350px;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="mb-40 d-flex flex-wrap w-100" v-if="title">
            <h3 class="title" v-html="title"></h3>
            <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
        </div>
        <a v-if="location" class="position-relative" :href="route('nl.location', (location.slug != null ? {'slug': location.slug} : {'slug': location.post_name}))">
            <div class="mx-n24 mx-md-0">
                <div class="location-banner">
                    <img v-if="location.acf && location.acf.image" :src="location.acf.image.url" :alt="location.post_name">
                    <div class="content">
                        <h2 v-if="location.post_name" class="mb-8 text-white title">{{ location.post_title ? location.post_title : location.title.rendered }}</h2>
                        <p v-if="location.acf && location.acf.highlighted_title" class="text-white font-weight-light description">
                            {{ location.acf.highlighted_title }}
                        </p>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import hasCta from "../mixins/has-cta";

export default {
    name: "pagePart.location-banner-row",

    mixins: [hasCta],

    props: {
        title: {
            type: String,
            required: false,
        },
        location: {
            type: Object,
            required: false,
            default: () => {
                return {
                    title: '',
                    description: '',
                    image: '',
                    tags: [],
                    media: [],
                    link: ''
                };
            },
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
    },
}
</script>